module.exports = __webpack_public_path__ + "img/avatar.e159dae4.png";